(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["real-product-video"] && !Shopify.designMode) return;
  try {
    (function () {
    function initRpv(root) {
      root.querySelectorAll('[data-rpv-open]').forEach(function (btn) {
        if (btn.dataset.rpvReady === 'true') return;
        btn.dataset.rpvReady = 'true';

        var modal = document.getElementById(btn.getAttribute('data-rpv-open'));
        if (!modal) return;

        function openModal() {
          modal.hidden = false;
          document.body.style.overflow = 'hidden';
          var video = modal.querySelector('video');
          if (video) {
            video.currentTime = 0;
            video.play().catch(function () {});
          }
        }

        function closeModal() {
          modal.hidden = true;
          document.body.style.overflow = '';
          var video = modal.querySelector('video');
          if (video) video.pause();
        }

        btn.addEventListener('click', openModal);
        modal.querySelectorAll('[data-rpv-close]').forEach(function (el) {
          el.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && !modal.hidden) closeModal();
        });
      });
    }

    initRpv(document);
    document.addEventListener('shopify:section:load', function (event) {
      initRpv(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
